import { render, staticRenderFns } from "./UploadThemeSidebar.vue?vue&type=template&id=9c1455be&scoped=true&"
import script from "./UploadThemeSidebar.vue?vue&type=script&lang=js&"
export * from "./UploadThemeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UploadThemeSidebar.vue?vue&type=style&index=0&id=9c1455be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1455be",
  null
  
)

export default component.exports